export default function () {
    const wrapper = document.querySelector(".text-expand-wrapper")
    const content = document.querySelector(".text-expand-content");
    const button = document.querySelector(".text-expand-button");
    if (!wrapper || !content || !button) return;

    const realHeight = content.scrollHeight;
    const cs = getComputedStyle(document.documentElement);
    const maxHeight = Number(cs.getPropertyValue('--maxTextHeight').replace("px", ""));

    if (!maxHeight || realHeight < maxHeight) return;

    wrapper.classList.add("expandable");

    button.addEventListener("click", function () {
        wrapper.classList.toggle("show");
    });
}